module.exports = __webpack_public_path__ + "img/cent-homepage-footer.0ce2a76c.jpg";